export default "__VITE_ASSET__BkAHt8dK__"